import { Component, NgZone, OnDestroy, OnInit } from '@angular/core';
import { Dashboard, ResultadosPeriodoDashboard, ResultDadosGraficos, ResultTotais, ResultVendasUltOrcPed, ValoresDashboard } from '../models/dashboard';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { PerfilDoUsuario, TipoDeLogAcesso } from '../models/enum';
import { UsuarioLogado } from '../models/usuario-logado';
import { UsuarioIntegrador } from '../models/usuario-integrador';
import { Promocao } from '../models/promocao';
import { Materia } from '../models/materia';
import { BehaviorSubject, Subscription } from 'rxjs';
import { Configuracao } from '../models/configuracao';
import { PedidoService } from '../services/pedido.service';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ClientesModalComponent } from '../modals/clientes-modal/clientes-modal.component';
import { Cliente } from '../models/cliente';
import { CRMHierarquiaUsuario } from '../models/crmhierarquia-usuario';
import { LogAcesso } from '../models/log-acesso';
import { CarregandoService } from '../services/carregando.service';
import { ClienteService } from '../services/cliente.service';
import { CRMHierarquiaUsuarioService } from '../services/crmhierarquia-usuario.service';
import { EtapaService } from '../services/etapa.service';
import { FuncionarioService } from '../services/funcionario.service';
import { GlobalService } from '../services/global.service';
import { LogAcessoService } from '../services/log-acesso.service';
import { MateriaService } from '../services/materia.service';
import { NotificacaoService } from '../services/notificacao.service';
import { PremissasService } from '../services/premissas.service';
import { PromocaoService } from '../services/promocao.service';
import { UsuarioIntegradorService } from '../services/usuario-integrador.service';
import { UtilitarioService } from '../services/utilitario.service';
import { PremissasSistema } from "../models/premissas-sistema";

// jquery
declare var $: any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, OnDestroy {
  public atualizouSubject: BehaviorSubject<any>;
  floatLabelControl = new FormControl('todos');

  dados: Dashboard;
  dadosPeriodoDashboard: ResultadosPeriodoDashboard = new ResultadosPeriodoDashboard();
  dadosResultGraficos: ResultDadosGraficos = new ResultDadosGraficos();
  dadosTotais: ResultTotais = new ResultTotais();

  ultimosOrcamentos: any[];
  ultimosPedidos: any[];

  pInicio: Date;
  pFim: Date;
  texto = 'Dashboard';
  periodoSelecionado = 1;

  periodos = [
    { id: 0, name: 'Todos' },
    { id: 1, name: 'Mês Atual' },
    { id: 2, name: 'Mês Passado' },
    { id: 3, name: 'Personalizado' },
    { id: 4, name: 'Hoje' },
    { id: 5, name: 'Ontem' },
    { id: 6, name: 'Semana' },
    { id: 7, name: 'Últimos 3 Meses' },
    { id: 8, name: 'Últimos 6 Meses' },
    { id: 9, name: 'Ano Atual' }
  ];

  multi: any[];

  public config: PerfectScrollbarConfigInterface = {};
  public configUltimos: PerfectScrollbarConfigInterface = {};

  // options
  showXAxis = false;
  showYAxis = true;
  gradient = false;
  showLegend = true;
  showXAxisLabel = false;
  xAxisLabel = 'Country';
  showYAxisLabel = true;

  colorScheme = {
    // domain: ['#5AA454', '#A10A28', '#C7B42C', '#AAAAAA']
  };

  perfil: PerfilDoUsuario;
  PerfilDoUsuario = PerfilDoUsuario;
  usuarioLogado: UsuarioLogado;
  integrador = false;

  vendedorSelecionado: any;
  integradorSelecionado: any;
  administrador = false;
  idVisual = {
    urlLogo: '',
    urlBackground: '',
    domain: [],
    cores: {
      corPrincipal: '',
      corDefault: '',
      corPrimary: '',
      corInfo: '',
      corSuccess: '',
      corWarning: '',
      corDanger: '',
      corRose: '',
      corGraficos: '',
      usarCorSecundariaNosBotoes: false,
    }
  };

  idUsuarioIntegrador;

  usuariosDoIntegrador: UsuarioIntegrador[] = [];

  promocoes: Promocao[] = [];
  materias: Materia[] = [];

  fidelidadeGoSolar = false;
  pMostrarRecebimentos = false;

  private configuracaoSubscription$: Subscription;

  etapas = [];
  etapasSelecionadas = [];

  configuracao: Configuracao = new Configuracao();

  pesquisaPorTimes = false;
  funcionario = null;

  buscouEtapas = false;
  buscouVendedores = false;
  buscouUsuarios = false;

  buscouDadosDashboard = false;
  buscouResultadosPeriodo = false;
  buscouUltimosOrcamentos = false;
  buscouUltimosPedidos = false;
  buscouResultGraficos = false;
  buscouResultTotais = false;

  buscouFidelidadeGoSolar = false;
  buscouPromocoes = false;
  buscouMaterias = false;
  buscouMostrarRecebimentosDashboard = false;
  buscouVisualizarArquivo = false;
  buscouClientes = false;
  premissasSistema: PremissasSistema = new PremissasSistema();

  private subscriptionUltimosOrcamentos$: Subscription;
  private subscriptionUltimosPedidos$: Subscription;
  private subscriptionDadosPeriodoDashboard$: Subscription;
  private subscriptionDadosTotais$: Subscription;
  private subscriptionDados$: Subscription;
  private subscriptionPromocoes$: Subscription;
  private subscriptionMaterias$: Subscription;

  constructor(
    private pedidoService: PedidoService,
    public utilitarioService: UtilitarioService,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private router: Router,
    private globalService: GlobalService,
    private clienteService: ClienteService,
    private funcionarioService: FuncionarioService,
    private hierarquiaService: CRMHierarquiaUsuarioService,
    public dialog: MatDialog,
    private materiaService: MateriaService,
    private promocaoService: PromocaoService,
    private premissasService: PremissasService,
    private usuarioIntegradorService: UsuarioIntegradorService,
    private etapaService: EtapaService,
    private logAcessoService: LogAcessoService,
    private spinner: NgxSpinnerService,
    private ngZone: NgZone,
  ) {
    this.atualizouSubject = new BehaviorSubject<any>(undefined);
  }

  public async ngOnInit() {
    this.buscarPremissasSistema();
    this.administrador = await this.globalService.administrador();
    this.perfil = await this.globalService.perfil();
    this.usuarioLogado = await this.globalService.consultaUsuario();
    this.integrador = await this.globalService.integrador();

    if (!this.integrador) {
      this.vendedorSelecionado = -1;
      this.buscarUltimosOrcamentos(this.periodoSelecionado);
      this.buscarUltimosPedidos(this.periodoSelecionado);
    } else {
      this.buscarResultadosPeríodoDashboard(this.periodoSelecionado);
      this.buscarResultTotais(this.periodoSelecionado);
      this.buscarDadosDashboard(this.periodoSelecionado);
    }

    this.buscarPromocoes();
    this.buscarMaterias();

    this.buscarMostrarRecebimentosDashboard();

    this.configuracaoSubscription$ = this.globalService.alterouConfiguracao.subscribe((conf: Configuracao) => {
      this.configuracao = conf;

      this.configuracao.esquemaDeCores = { domain: this.idVisual.domain };
    });
  }

  destroySubscriptionUltimosOrcamentos() {
    if (this.subscriptionUltimosOrcamentos$ !== null && this.subscriptionUltimosOrcamentos$ !== undefined) {
      this.subscriptionUltimosOrcamentos$.unsubscribe();
      this.subscriptionUltimosOrcamentos$ = undefined;
    }
  }

  destroySubscriptionUltimosPedidos() {
    if (this.subscriptionUltimosPedidos$ !== null && this.subscriptionUltimosPedidos$ !== undefined) {
      this.subscriptionUltimosPedidos$.unsubscribe();
      this.subscriptionUltimosPedidos$ = undefined;
    }
  }

  destroySubscriptionDadosPeriodoDashboard() {
    if (this.subscriptionDadosPeriodoDashboard$ !== null && this.subscriptionDadosPeriodoDashboard$ !== undefined) {
      this.subscriptionDadosPeriodoDashboard$.unsubscribe();
      this.subscriptionDadosPeriodoDashboard$ = undefined;
    }
  }

  destroySubscriptionDadosTotais() {
    if (this.subscriptionDadosTotais$ !== null && this.subscriptionDadosTotais$ !== undefined) {
      this.subscriptionDadosTotais$.unsubscribe();
      this.subscriptionDadosTotais$ = undefined;
    }
  }

  destroySubscriptionDados() {
    if (this.subscriptionDados$ !== null && this.subscriptionDados$ !== undefined) {
      this.subscriptionDados$.unsubscribe();
      this.subscriptionDados$ = undefined;
    }
  }

  destroySubscriptionPromocoes() {
    if (this.subscriptionPromocoes$ !== null && this.subscriptionPromocoes$ !== undefined) {
      this.subscriptionPromocoes$.unsubscribe();
      this.subscriptionPromocoes$ = undefined;
    }
  }

  destroySubscriptionMaterias() {
    if (this.subscriptionMaterias$ !== null && this.subscriptionMaterias$ !== undefined) {
      this.subscriptionMaterias$.unsubscribe();
      this.subscriptionMaterias$ = undefined;
    }
  }

  buscarPremissasSistema() {
    this.carregandoService.mostra('buscarPremissasSistema');
    this.premissasService.consultarPremissasSistema().subscribe(
      (premissas) => {
        this.premissasSistema = premissas;

        this.carregandoService.esconde('buscarPremissasSistema');
      },
      (erro) => {
        this.carregandoService.esconde('buscarPremissasSistema');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarDadosDashboard(tipo, inicio?, fim?) {
    let etapas;

    if (this.etapasSelecionadas && this.etapasSelecionadas.length > 0) {
      etapas = this.etapasSelecionadas.join(',');
    }

    this.spinner.show('spnResultados');
    this.buscouDadosDashboard = false;

    this.destroySubscriptionDados();

    this.subscriptionDados$ = this.pedidoService.buscarDadosDashboard(tipo, inicio, fim, (this.vendedorSelecionado === 0 ? undefined : this.vendedorSelecionado === -1 ? this.usuarioLogado.id : this.vendedorSelecionado), this.integradorSelecionado, this.integrador && !this.usuarioLogado.verTodosPedidos ? this.usuarioLogado.idUsuarioIntegrador : this.idUsuarioIntegrador, etapas, this.pesquisaPorTimes).subscribe(
      (forms) => {
        this.dados = forms;

        console.log('dados:', this.dados);

        this.atualizouSubject.next(this.dados);

        this.spinner.hide('spnResultados');
        this.buscouDadosDashboard = true;
      },
      (erro) => {
        this.spinner.hide('spnResultados');
        this.buscouDadosDashboard = true;
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarResultadosPeríodoDashboard(tipo, inicio?, fim?) {
    let etapas;

    if (this.etapasSelecionadas && this.etapasSelecionadas.length > 0) {
      etapas = this.etapasSelecionadas.join(',');
    }

    this.spinner.show('spnResultadosPeríodoDashboard');
    this.buscouResultadosPeriodo = false;

    this.destroySubscriptionDadosPeriodoDashboard();

    this.subscriptionDadosPeriodoDashboard$ = this.pedidoService.buscarResultadosPeriodoDashboard(
      tipo,
      inicio,
      fim,
      (this.vendedorSelecionado === 0 ? undefined : this.vendedorSelecionado === -1 ? this.usuarioLogado.id : this.vendedorSelecionado),
      this.integradorSelecionado,
      this.integrador && !this.usuarioLogado.verTodosPedidos ? this.usuarioLogado.idUsuarioIntegrador : this.idUsuarioIntegrador,
      etapas,
      this.pesquisaPorTimes
    ).subscribe(
      (data) => {
        this.dadosPeriodoDashboard = data;

        this.spinner.hide('spnResultadosPeríodoDashboard');
        this.buscouResultadosPeriodo = true;
      },
      (erro) => {
        this.spinner.hide('spnResultadosPeríodoDashboard');
        this.buscouResultadosPeriodo = true;
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarUltimosOrcamentos(tipo, inicio?, fim?) {
    let etapas;

    if (this.etapasSelecionadas && this.etapasSelecionadas.length > 0) {
      etapas = this.etapasSelecionadas.join(',');
    }

    this.buscouUltimosOrcamentos = false;

    this.destroySubscriptionUltimosOrcamentos();

    this.subscriptionUltimosOrcamentos$ = this.pedidoService.buscarUltimosOrcamentos(
      tipo, inicio, fim, (this.vendedorSelecionado === 0 ? undefined : this.vendedorSelecionado === -1 ? this.usuarioLogado.id : this.vendedorSelecionado), this.integradorSelecionado, this.integrador && !this.usuarioLogado.verTodosPedidos ? this.usuarioLogado.idUsuarioIntegrador : this.idUsuarioIntegrador, etapas, this.pesquisaPorTimes
    ).subscribe(
      (data) => {
        this.ultimosOrcamentos = data;
        this.buscouUltimosOrcamentos = true;
      },
      (erro) => {
        this.buscouUltimosOrcamentos = true;
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarUltimosPedidos(tipo, inicio?, fim?) {
    let etapas;

    if (this.etapasSelecionadas && this.etapasSelecionadas.length > 0) {
      etapas = this.etapasSelecionadas.join(',');
    }

    this.buscouUltimosPedidos = false;

    this.destroySubscriptionUltimosPedidos();

    this.subscriptionUltimosPedidos$ = this.pedidoService.buscarUltimosPedidos(
      tipo, inicio, fim, (this.vendedorSelecionado === 0 ? undefined : this.vendedorSelecionado === -1 ? this.usuarioLogado.id : this.vendedorSelecionado), this.integradorSelecionado, this.integrador && !this.usuarioLogado.verTodosPedidos ? this.usuarioLogado.idUsuarioIntegrador : this.idUsuarioIntegrador, etapas, this.pesquisaPorTimes
    ).subscribe(
      (data) => {
        this.ultimosPedidos = data;
        this.buscouUltimosPedidos = true;
      },
      (erro) => {
        this.buscouUltimosPedidos = true;
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarResultTotais(tipo, inicio?, fim?) {
    let etapas;

    if (this.etapasSelecionadas && this.etapasSelecionadas.length > 0) {
      etapas = this.etapasSelecionadas.join(',');
    }

    this.spinner.show('spnResultTotais');
    this.buscouResultTotais = false;

    this.destroySubscriptionDadosTotais();

    this.subscriptionDadosTotais$ = this.pedidoService.buscarDadosTotais(
      tipo,
      inicio,
      fim,
      (this.vendedorSelecionado === 0 ? undefined : this.vendedorSelecionado === -1 ? this.usuarioLogado.id : this.vendedorSelecionado),
      this.integradorSelecionado,
      this.integrador && !this.usuarioLogado.verTodosPedidos ? this.usuarioLogado.idUsuarioIntegrador : this.idUsuarioIntegrador,
      etapas,
      this.pesquisaPorTimes
    ).subscribe(
      (data) => {
        this.dadosTotais = data;

        this.spinner.hide('spnResultTotais');
        this.buscouResultTotais = true;
      },
      (erro) => {
        this.spinner.hide('spnResultTotais');
        this.buscouResultTotais = true;
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarMostrarRecebimentosDashboard() {
    this.buscouMostrarRecebimentosDashboard = false;
    this.premissasService.consultarMostrarRecebimentosDashboard().subscribe(rec => {
      if (rec.valor) {
        this.pMostrarRecebimentos = rec.valor;
      }

      this.buscouMostrarRecebimentosDashboard = true;
    }, (erro) => {
      this.buscouMostrarRecebimentosDashboard = true;
      this.notificacaoService.erro(erro);
    });
  }

  buscarPromocoes() {
    this.buscouPromocoes = false;

    this.destroySubscriptionPromocoes();

    this.subscriptionPromocoes$ = this.promocaoService.consultarPromocoesDashboard().subscribe(
      (promocoes) => {
        this.promocoes = promocoes;

        const promises = this.promocoes.map(promo => {
          if (!promo.buscouImagem) {
            promo.imagem$ = this.promocaoService.consultarImagemThumbPorId(promo.id)
              .map(m => this.utilitarioService.toBase64ComInicio(m))
              .toPromise();

            return promo.imagem$.then(p => {
              promo.buscouImagem = true;
            });
          }
          return Promise.resolve();
        });

        Promise.all(promises).then(() => {
          // Espera o Angular renderizar o DOM
          this.ngZone.runOutsideAngular(() => {
            setTimeout(() => {
              $('#carouselIndicators-mesc').carousel({
                interval: 5000,
                ride: 'carousel'
              });
            }, 100);
          });
        });

        this.buscouPromocoes = true;
      },
      (erro) => {
        this.buscouPromocoes = true;
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarMaterias() {
    this.buscouMaterias = false;

    this.destroySubscriptionMaterias();

    this.subscriptionMaterias$ = this.materiaService.consultarMateriasDashboard().subscribe(
      (materias) => {
        this.materias = materias;

        this.materias.forEach(mat => {
          if (!mat.buscouImagem) {
            mat.imagem$ = this.materiaService.consultarImagemThumbPorId(mat.id)
              .map(m => this.utilitarioService.toBase64ComInicio(m)).toPromise();
            mat.imagem$.then(p => {
              mat.buscouImagem = true;
            });
          }
        });

        this.buscouMaterias = true;
      },
      (erro) => {
        this.buscouMaterias = true;
        this.notificacaoService.erro(erro);
      }
    );
  }

  visualizarPromocao(promo) {
    if (promo.idProduto) {
      this.router.navigate(['/kitfechado'], {
        state: { idProduto: promo.idProduto },
      });
      return;
    }

    this.buscouVisualizarArquivo = false;
    this.promocaoService.consultarImagemPorId(promo.id)
      .subscribe(arq => {
        this.utilitarioService.mostrarImagemBlob(arq, '');
        this.buscouVisualizarArquivo = true;
      },
        (erro) => {
          this.buscouVisualizarArquivo = true;
          this.notificacaoService.erro(erro);
        }
      );
  }

  onSelect(event) {
    this.irParaPedidos(this.dadosResultGraficos.valoresGraficoQuantidades.find(p => p.name === event.name).id);
  }

  irParaPedidos(etapa) {
    this.router.navigate(['pedidos'],
      {
        state: {
          filtro: { dataInicio: this.dados.dataInicio, dataFim: this.dados.dataFim, etapa: etapa, vendedor: this.vendedorSelecionado, integrador: this.integradorSelecionado }
        }
      });
  }

  ngOnDestroy() {
    if (this.configuracaoSubscription$ !== undefined && this.configuracaoSubscription$ !== null) {
      this.configuracaoSubscription$.unsubscribe();
    }

    this.destroySubscriptionDados();
    this.destroySubscriptionDadosPeriodoDashboard();
    this.destroySubscriptionDadosTotais();
    this.destroySubscriptionMaterias();
    this.destroySubscriptionPromocoes();
    this.destroySubscriptionUltimosOrcamentos();
    this.destroySubscriptionUltimosPedidos();
  }


  handleRowClick(route: string, state: object) {
    this.router.navigate([route], { state });
  }

  gerarLogAcesso(idCupom: string, tipo: TipoDeLogAcesso) {
    const logAcesso: LogAcesso = {
      tipo,
      idCupom,
    };

    this.logAcessoService.Salvar(logAcesso).subscribe(() => { });
  }

  editarPedido(flag: number, idCupom: string) {
    this.gerarLogAcesso(idCupom, TipoDeLogAcesso.EditarPedido);
    this.router.navigate(['/pedidos/editar', idCupom]);
  }

}
